// MavLink Message IDs
export const MAVLINK_MESSAGE_IDS = {
  HEARTBEAT: 0,
  PARAM_VALUE: 22,
  GPS_RAW_INT: 24,
  ATTITUDE: 30,
  GLOBAL_POSITION_INT: 33,
  MISSION_REQUEST: 40,
  MISSION_CURRENT: 42,
  MISSION_COUNT: 44,
  MISSION_ACK: 47,
  MISSION_REQUEST_INT: 51,
  MISSION_ITEM_INT: 73,
  VFR_HUD: 74,
  COMMAND_LONG: 76,
  COMMAND_ACK: 77,
  BATTERY_STATUS: 147,
  AUTOPILOT_VERSION: 148,
  CAMERA_FEEDBACK: 180,
  MAG_CAL_PROGRESS: 191,
  MAG_CAL_REPORT: 192,
  EKF_STATUS_REPORT: 193,
  VIBRATION: 241,
  HOME_POSITION: 242,
  EXTENDED_SYS_STATE: 245,
  STATUSTEXT: 253,
};
